import kebabCase from 'lodash/kebabCase';
import * as Pages from 'pages';

const pages = Pages as Record<string, React.FC>;
const routes: Array<{ Page: React.FC; path: string }> = [];

for (const page of Object.keys(pages)) {
	routes.push({ Page: pages[page], path: kebabCase(page) });
}

export const ROUTES = routes;

export type PageDefinition = Readonly<(typeof ROUTES)[0]>;
